module.exports = __webpack_public_path__ + "static/img/logo.074ff4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo/logo.png
// module id = INMq
// module chunks = 0